import React, { Fragment } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import SEO from "../../components/ceo/CEO";

const NotFound = () => {
  return (
    <Fragment>
      <SEO
        title="Page Not Found"
        description="Oops! The page you're looking for doesn't exist. Check the URL or return to the homepage."
        url="https://shallafg.org/404"
      />
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
          color: "#FFFFFF",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "0 20px",
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h1"
            sx={{
              fontWeight: 800,
              fontSize: { xs: "4rem", md: "6rem" },
              letterSpacing: "3px",
              textTransform: "uppercase",
              color: "#A9C9EA",
            }}
          >
            404
          </Typography>
          <Typography
            variant="h5"
            sx={{
              marginTop: "20px",
              fontWeight: 600,
              fontSize: { xs: "1.2rem", md: "1.8rem" },
              color: "#FFFFFF",
              marginBottom: "20px",
            }}
          >
            Oops! The page you're looking for doesn't exist.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#D1D5DB",
              marginBottom: "40px",
            }}
          >
            It seems like you've hit a broken link or entered a wrong URL.
            Please check the URL or return to the homepage.
          </Typography>
          <Button
            component={Link}
            to="/"
            sx={{
              backgroundColor: "#10a7e0",
              color: "#FFFFFF",
              padding: "12px 32px",
              borderRadius: "50px",
              fontSize: "1.2rem",
              fontWeight: 600,
              textTransform: "uppercase",
              "&:hover": {
                backgroundColor: "#0056b3",
              },
            }}
          >
            Go Back Home
          </Button>
        </Container>
      </Box>
    </Fragment>
  );
};

export default NotFound;
